import React, { useReducer, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Auth } from '../../apis/secure/auth';

import AuthReducer from './AuthReducer';

const initialState = {
  authenticated: false,
  user: {
    userId: null,
    alias: null,
    role: null,
    placeId: null,
  },
  loading: false,
};

export const AuthContext = React.createContext(initialState);
export const AuthStore = ({ children }) => {
  const history = useHistory();
  const [state, dispatch] = useReducer(AuthReducer, initialState);
  const { authenticated, user, loading } = state;
  const { placeId, userId } = user;
  const isAuthenticated = authenticated && placeId && userId;
  const notAuthenticated = !isAuthenticated && !loading;

  const tryToLogIn = async () => {
    dispatch({type: 'SET_LOADING', payload: { loading: true }});
    const { success, user: tokenUser } = await Auth.loginWithRefreshToken();
    if (!success) {
      dispatch({type: 'SET_LOADING', payload: { loading: false }});
      history.replace('/login');
    } else {
      dispatch({ type: 'LOGIN', payload: { user: tokenUser } });
    }
  };

  useEffect(() => {
    if (notAuthenticated) {
      tryToLogIn();
    }
    const handleOnFocus = async () => {
      if (document.hidden) {
      } else {
        tryToLogIn();
      }
    };

    document.addEventListener('visibilitychange', handleOnFocus, true);
    return () => {
      document.removeEventListener('visibilitychange', handleOnFocus, true);
    };
  }, []);

  const logout = async () => {
    await Auth.logout();
    dispatch({ type: 'LOGOUT', payload: {} });
  };

  return (
    <AuthContext.Provider value={[state, dispatch, { logout }]}>{children}</AuthContext.Provider>
  );
};

export default AuthStore;
